// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\PortCallProfile\PortCallProfileViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PortCall, PortCallData, PortCallOptions } from 'data/models/PortCall';
import { PortCallProfileTopicCard as _PortCallProfileTopicCard, PortCallProfileTopicCardData as _PortCallProfileTopicCardData, PortCallProfileTopicCardOptions as _PortCallProfileTopicCardOptions } from 'data/models/PortCallProfile';
import { TopicCard, TopicCardData, TopicCardOptions } from 'data/models/TopicCard';
import { DomainRights, PortCallRights } from 'server/enums/Rights';

// PortCallProfileResponseData is the class that PortCallProfileResponse serializes to/from
export interface PortCallProfileResponseData {
    Id : number;
	
    PortCall : PortCallData | null;
    TopicCards : _PortCallProfileTopicCardData[] | null;
	
    ApplicableTopicCardTemplatesCount : number;
    AssignableAgents : number[];
    DomainRights : DomainRights;
    Rights : PortCallRights;
    SchedulingAuthorityEditors : number[];
}

// PortCallProfileResponseOptions is the class which may be passed to the PortCallProfileResponse constructor to define optional initial data values
export interface PortCallProfileResponseOptions {
    Id : number;
	
    PortCall? : PortCallOptions | null;
    TopicCards? : _PortCallProfileTopicCardOptions[] | null;
	
    ApplicableTopicCardTemplatesCount? : number;
    AssignableAgents? : number[];
    DomainRights? : DomainRights;
    Rights? : PortCallRights;
    SchedulingAuthorityEditors? : number[];
}

export class PortCallProfileResponse {
    public Id : DataSignal<number>;
	
    public PortCall : DataSignal<PortCall | null>;
    public TopicCards : SDataArray<_PortCallProfileTopicCard>;
	
    public ApplicableTopicCardTemplatesCount : DataSignal<number>;
    public AssignableAgents : SDataArray<number>;
    public DomainRights : DataSignal<DomainRights>;
    public Rights : DataSignal<PortCallRights>;
    public SchedulingAuthorityEditors : SDataArray<number>;

    constructor();
    constructor(data : PortCallProfileResponseOptions);
    constructor(data: PortCallProfileResponseOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.PortCall = S.value<PortCall | null>(null);
        this.TopicCards = SArray<_PortCallProfileTopicCard>([]);
	    
        this.ApplicableTopicCardTemplatesCount = jsonableObservable(S.value<number>(data && data.ApplicableTopicCardTemplatesCount !== undefined ? data.ApplicableTopicCardTemplatesCount : 0));
        this.AssignableAgents = jsonableObservable(SArray<number>(data && data.AssignableAgents !== undefined ? data.AssignableAgents : []));
        this.DomainRights = jsonableObservable(S.value<DomainRights>(data && data.DomainRights !== undefined ? data.DomainRights : 0));
        this.Rights = jsonableObservable(S.value<PortCallRights>(data && data.Rights !== undefined ? data.Rights : 0));
        this.SchedulingAuthorityEditors = jsonableObservable(SArray<number>(data && data.SchedulingAuthorityEditors !== undefined ? data.SchedulingAuthorityEditors : []));
    }

    static key(obj : PortCallProfileResponse) {
        return obj.Id();
    }
    
    static dataKey(obj : PortCallProfileResponseOptions) {
        return obj.Id;
    }

    static update(obj : PortCallProfileResponse, data : PortCallProfileResponseOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.ApplicableTopicCardTemplatesCount !== undefined) obj.ApplicableTopicCardTemplatesCount(data.ApplicableTopicCardTemplatesCount);
            if (data.AssignableAgents !== undefined) obj.AssignableAgents(data.AssignableAgents);
            if (data.DomainRights !== undefined) obj.DomainRights(data.DomainRights);
            if (data.Rights !== undefined) obj.Rights(data.Rights);
            if (data.SchedulingAuthorityEditors !== undefined) obj.SchedulingAuthorityEditors(data.SchedulingAuthorityEditors);
        });
    }
}

// PortCallProfileTopicCardData is the class that PortCallProfileTopicCard serializes to/from
export interface PortCallProfileTopicCardData {
    Id : number;
	
    Card : TopicCardData | null;
	
    CanConfirm : boolean;
}

// PortCallProfileTopicCardOptions is the class which may be passed to the PortCallProfileTopicCard constructor to define optional initial data values
export interface PortCallProfileTopicCardOptions {
    Id : number;
	
    Card? : TopicCardOptions | null;
	
    CanConfirm? : boolean;
}

export class PortCallProfileTopicCard {
    public Id : DataSignal<number>;
	
    public Card : DataSignal<TopicCard | null>;
	
    public CanConfirm : DataSignal<boolean>;

    constructor();
    constructor(data : PortCallProfileTopicCardOptions);
    constructor(data: PortCallProfileTopicCardOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Card = S.value<TopicCard | null>(null);
	    
        this.CanConfirm = jsonableObservable(S.value<boolean>(data && data.CanConfirm !== undefined ? data.CanConfirm : false));
    }

    static key(obj : PortCallProfileTopicCard) {
        return obj.Id();
    }
    
    static dataKey(obj : PortCallProfileTopicCardOptions) {
        return obj.Id;
    }

    static update(obj : PortCallProfileTopicCard, data : PortCallProfileTopicCardOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.CanConfirm !== undefined) obj.CanConfirm(data.CanConfirm);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PortCallProfile.ts